//Innyx Component
import {
  InputCustom,
  InputSelect,
  InputDate,
  GradeEdicao,
  MunicipioUf,
  MunicipioUfPerfilDados,
  RedeDeEnsinoPerfilDados,
  CustomFilterButton,
  TabelaAccordion,
  Tabela,
  TabelaInput,
  Paginacao,
  paginacaoLista,
} from "./components";

import BotaoCadastrar from "./components/Botoes/BotaoCadastrar.vue";

export default (app) => {
  const components = {
    InputCustom,
    InputSelect,
    InputDate,
    GradeEdicao,
    MunicipioUf,
    MunicipioUfPerfilDados,
    RedeDeEnsinoPerfilDados,
    CustomFilterButton,
    TabelaAccordion,
    Tabela,
    TabelaInput,
    Paginacao,
    paginacaoLista,
    BotaoCadastrar,
  };

  Object.entries(components).forEach(([name, component]) =>
    app.component(name, component)
  );
};
